import * as React from 'react';
import { useState, useEffect, useMemo } from "react";
import { useAccountStore } from "../../../hooks/admin/account";
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import { AgGridReact } from 'ag-grid-react';
import store from 'src/storeWire';
import { system_notification } from 'src/store/slice/system';
import useReduxState from 'src/hooks/useReduxState';
import NoResultContent from '../../HomePageContent/NoResultContent';
import { __remove, __set } from 'src/store/axios_indicator';
import Constants from 'src/support/Constants';
import Helper from 'src/support/Helper';
import Admin from "@system/config/admin";
import { useAdminCommonStore } from '../../../hooks/admin/adminCommon';
import { Tooltip } from 'src/component/Tooltip';
import { useUserStore } from 'src/hooks/admin/user';
import RoleSelection from '../AdminModals/RoleSelection';
import System from 'src/helper/system';
import { getForbiddenResponseMessage } from 'src/service/forbiddenResponseMessage';

var roleData = [];
var isEditGlobal = false;

export function SponsorAccountList(props) {
  const [__check] = useAxiosIndicatorCheck();
  const [{ accountUserList, totalAccountUser, accountUserListMessage }, { get_account_user_list, export_account_user_list, email_account_user_list }, { set_account_user_list_message }] = useAccountStore();
  const [selectionCount, setSelectionCount] = useState(0);
  const [refreshGrid, setRefreshGrid] = useReduxState(false, 'setRefreshGrid');
  const [, setUserListErrAlert] = useReduxState("", 'setUserListErrAlert');
  const [, setErrAlertType] = useReduxState("", 'setErrAlertType');
  const [isEdit] = useReduxState(false, 'setIsEdit');
  const [rowData, setRowData] = useState([]);
  const gridRef = React.useRef();
  const userId = props.userId;
  const [, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [agGridFiltered, setAgGridFiltered] = useState(0);
  const [{ accountDetail }] = useAccountStore();
  const [{ roleList }] = useAdminCommonStore();
  const [{ selectedRoles }, { }, { set_role_selection_popup_status, set_select_user_sponsor_accounts, update_user_roles }] = useUserStore();
  const [selectedIndex, setIndex] = useState(-1);

  useEffect(() => {
    async function fetchHere() {

      await fetchAPICall();
      __remove('ACCOUNT_USER_API_CALL')
    }
    __set('ACCOUNT_USER_API_CALL')
    fetchHere();
  }, []);

  const isRowSelectable = useMemo(() => {
    return (params) => {
      return (params.data && params.data.Source !== 'SAP');
    };
  }, []);

  useEffect(() => {
    async function fetchHere() {
      setSelectionCount(0);
      await fetchAPICall();
      setRefreshGrid(false);
      __remove('ACCOUNT_USER_API_CALL')
    }
    if (refreshGrid) {
      __set('ACCOUNT_USER_API_CALL')
      fetchHere();
    }
  }, [refreshGrid]);


  useEffect(() => {
    const _userList = [];

    if (accountUserList.length > 0) {
      accountUserList.map((ele, idx) => {
        const _data = {
          AccountName: accountDetail.account_name,
          AccountNumber: accountDetail.account_number,
          AccountStatus: accountDetail.active ? 'Active' : 'Inactive',
          AccountCreatedOn: accountDetail.createdDate ? Helper.getDatepickerFormatAdminConsole(accountDetail.createdDate) : "",
          AccountUpdatedOn: accountDetail.updatedDate ? Helper.getDatepickerFormatAdminConsole(accountDetail.updatedDate) : "",
          Speedboat: accountDetail.speedboat === 'T' ? 'Abacus' : accountDetail.speedboat === 'S' ? 'Silica' : 'EBV',
          SalesOrg: accountDetail.sales_org,
          Description: accountDetail.description,
          Currency: accountDetail.currency,
          Payment: accountDetail.payment_term_id,
          BillToCountry: accountDetail.bill_to_country_code,
          Sdi: accountDetail.sdi_number,
          CreditRisk: accountDetail.creditRisk === true ? 'Yes' : accountDetail.creditRisk === false ? 'No' : '',
          OrderBlock: accountDetail.orderBlock === true ? 'Yes' : accountDetail.orderBlock === false ? 'No' : '',
          Role: ele.role ? ele.role.split(',').map(v => v.trim()) : [],
          Email: ele.email,
          FirstName: ele.firstName,
          LastName: ele.lastName,
          TelephoneNumber: ele.telephone_Number,
          MobileNumber: ele.mobile_Number,
          Source: ele.source,
          Status: ele.status ? 'Active' : 'Inactive',
          CreatedOn: ele.createdOn ? Helper.getDatepickerFormatAdminConsole(ele.createdOn) : "",
          UserId: ele.user_id,
        }
        _userList.push(_data);
      })
      setRowData(_userList)
    } else {
      setRowData([])
    }

  }, [accountUserList, accountDetail]);

  const loadUserId = (e) => {
    return <>
      <a href={Admin.getAdminUserDetailURL() + '?uid=' + (e?.data?.UserId ? e?.data?.UserId : e.node.allLeafChildren[0].data.UserId)} className='' target="_blank"> {e.value}</a>
    </>
  }

  const loadAccountNumber = (e) => {
    return <>
      <a href={Admin.getAdminUserDetailURL() + '?uid=' + (e?.data?.UserId ? e?.data?.UserId : e.node.allLeafChildren[0].data.UserId)} className='' target="_blank"> {e.value}</a>
    </>
  }

  const openPopup = (account, rowIndex) => {
    setIndex(rowIndex)
    set_select_user_sponsor_accounts({ account, userData: { userName: Helper.valueIsNotNull(account.UserName) ? account.UserName : (account?.FirstName + ' ' + account?.LastName) } })
    set_role_selection_popup_status(true);
  };

  useEffect(() => {
    roleData = roleList;
  }, [roleList])

  const addRole = (e) => {
    let data;
    if (e.data) {
      data = e.data;
    } else if (e.node.field === 'Role') {
      data = e.node.allLeafChildren[0]?.data;
    } else return "";
    const role = data.Role;
    let renderedRole = Helper.renderRoles(role, roleData);
    const cellContent = (data.Source === "SAP" || isEditGlobal) ? <span className={'text-black-stone'}>{role.length > 0 ? renderedRole : 'Select Role (required)'}</span> :
      <a className={'text-blue2'} onClick={() => {
        openPopup(e.data, e.rowIndex)
      }}><u>
          {role.length > 0 ? renderedRole : 'Select Role (required)'}
        </u>
      </a>

    return role.length > 0 ? <Tooltip
      arrow={false}
      position={'top left'}
      opener={() => cellContent}
      content={() => `${renderedRole}`}
    /> : cellContent;
  }

  const roleSortingAgGrid = (roleA, roleB) => {
    let renderedRoleA = Helper.renderRoles(roleA, roleData);
    let renderedRoleB = Helper.renderRoles(roleB, roleData);
    return renderedRoleA.localeCompare(renderedRoleB);
  }

  // eslint-disable-next-line no-unused-vars
  const [columnDefs, setColumnDefs] = useState([
    { field: 'AccountName', hide: true, headerName: 'ACCOUNT NAME', },
    { field: 'AccountNumber', hide: true, headerName: 'ACCOUNT NUMBER', },
    { field: 'AccountStatus', hide: true, headerName: 'ACCOUNT STATUS', },
    { field: 'AccountCreatedOn', hide: true, headerName: 'ACCOUNT CREATED ON', },
    { field: 'AccountUpdatedOn', hide: true, headerName: 'ACCOUNT UPDATED ON', },
    { field: 'Speedboat', hide: true, headerName: 'SPEEDBOAT', },
    { field: 'SalesOrg', hide: true, headerName: 'SALES ORG', },
    { field: 'Description', hide: true, headerName: 'DESCRIPTION', },
    { field: 'Currency', hide: true, headerName: 'CURRENCY', },
    { field: 'Payment', hide: true, headerName: 'PAYMENT TERM ID', },
    { field: 'BillToCountry', hide: true, headerName: 'BILL TO COUNTRY', },
    { field: 'Sdi', hide: true, headerName: 'SDI', },
    { field: 'CreditRisk', hide: true, headerName: 'CREDIT RISK', },
    { field: 'OrderBlock', hide: true, headerName: 'ORDER BLOCK', },
    {
      field: '', pinned: 'left', lockPosition: "left",
      headerCheckboxSelection: true,
      checkboxSelection: true,
      showDisabledCheckboxes: true,
      width: 50,
      enableFilter: false
    },
    {
      field: 'Email', pinned: 'left', minWidth: 150, lockPosition: "left",
      width: 50,
      enableFilter: false,
      suppressMovable: true,
      headerName: 'EMAIL',
      headerTooltip: 'EMAIL',
      sortable: true, comparator: Helper.textSortingAgGrid,
      cellRenderer: loadUserId
    },
    {
      field: 'FirstName', pinned: 'left', minWidth: 200, suppressMovable: true, lockPosition: "left",
      headerName: 'FIRST NAME',
      headerTooltip: 'FIRST NAME',
      sortable: true, comparator: Helper.textSortingAgGrid
    },

    { field: 'LastName', pinned: 'left', headerName: 'LAST NAME', lockPosition: "left", headerTooltip: 'LAST NAME', sortable: true, comparator: Helper.textSortingAgGrid },
    {
      field: 'Role',
      minWidth: 130, headerName: 'ROLE', headerTooltip: 'ROLE', sortable: true,
      comparator: roleSortingAgGrid,
      cellRenderer: addRole
    },
    { field: 'TelephoneNumber', minWidth: 130, headerName: 'TELEPHONE NUMBER', headerTooltip: 'TELEPHONE NUMBER', sortable: true, comparator: Helper.textSortingAgGrid, cellClass: 'stringType' },
    { field: 'MobileNumber', minWidth: 130, headerName: 'MOBILE NUMBER', headerTooltip: 'MOBILE NUMBER', sortable: true, comparator: Helper.textSortingAgGrid, cellClass: 'stringType' },
    {
      field: 'CreatedOn',
      minWidth: 130,
      headerName: 'CREATED ON',
      headerTooltip: 'CREATED ON',
      sortable: true,
      comparator: Helper.dateSortingAgGrid,
      filter: 'agDateColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        comparator: Helper.calendarAgGridComparator,
      }
    },
    { field: 'Source', minWidth: 130, headerName: 'SOURCE', headerTooltip: 'SOURCE', sortable: true, comparator: Helper.textSortingAgGrid },
    { field: 'Status', minWidth: 130, headerName: 'STATUS', headerTooltip: 'STATUS', sortable: true, comparator: Helper.textSortingAgGrid },
  ]);

  
  const excelStyles = useMemo(() => { 
    return [
          {
              id: 'numberType',
              numberFormat: {
                  format: '0',
              },
          },
          {
              id: 'negativeInBrackets',
              numberFormat: {
                  format: '$[blue] #,##0;$ [red](#,##0)',
              },
          },
          {
              id: 'booleanType',
              dataType: 'Boolean',
          },
          {
              id: 'stringType',
              dataType: 'String',
          },
          {
              id: 'dateType',
              dataType: 'DateTime',
          },
      ];
  }, []);

  const popupParent = useMemo(() => { 
    return document.body;
  }, []);

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      sortable: true,
      filter: true,
      enableRowGroup: true,
      enableValue: true,
      width: 150,
      // minWidth: 130,
      resizable: true
      // suppressMovable: true,
      // menuTabs: ['filterMenuTab', 'columnsMenuTab'],
    };
  }, []);

  const onSelectionChanged = () => {
    setSelectionCount(gridRef?.current?.api?.getSelectedRows().length);
  }

  const fetchAPICall = async () => {
    await get_account_user_list(props.accountDetails)
  };
  const onUnsponsorAcct = () => {
    if (gridRef.current.api.getSelectedRows().length > 0) {
      const list = gridRef.current.api.getSelectedRows();
      store.dispatch(system_notification({
        name: 'UnsponsorUserAcct',
        data: {
          userId, list,
          base: 'accountDetails'
        },
      }));
    }
  }

  const onExportAll = async () => {
    $('#emailFilter').removeClass('open');
    if (isEdit)
      return false;
    __set('COMMON_API_CALL');
    try {
      set_account_user_list_message('');
      if (totalAccountUser <= 2000) {
        const data = await export_account_user_list({ ...props.accountDetails, exportFileExtention: "xlsx" });
        Helper.downloadFileFromRes(data, 'account_user_list.xlsx');
        setUserListErrAlert(Constants.downloadMsg, 'success', 'addUser');
        setErrAlertType('success');
      }
      else {
        const res = await email_account_user_list({ ...props.accountDetails, exportFileExtention: "xlsx" });
        setUserListErrAlert("File will be sent as an email attachment due to large number of records", 'success', 'addUser');
        setErrAlertType('success');
      }
    } catch (error) {
      set_account_user_list_message(getForbiddenResponseMessage(error) || 'Something went wrong');
    } finally {
      __remove('COMMON_API_CALL');
    }
  }
  const exportGrid = async () => {
    $('#emailFilter').removeClass('open');
    __set('COMMON_API_CALL');
    try {
      set_account_user_list_message('');
      if (agGridFiltered <= 2000) {
        const allColumnState = gridColumnApi.getColumnState();
        const customColumns = allColumnState.map((column) => column.colId);
        let params = { fileName: `account_user_list.xlsx`, sheetName: "Account", columnKeys: customColumns.slice(1) };
        await gridRef.current.api.exportDataAsExcel(params);
        setUserListErrAlert(Constants.downloadMsg, 'success', 'addUser');
        setErrAlertType('success');
      }
      else {
        const res = await email_account_user_list({ ...props.accountDetails, exportFileExtention: "xlsx" });
        setUserListErrAlert("File will be sent as an email attachment due to large number of records", 'success', 'addUser');
        setErrAlertType('success');
      }
    } catch (error) {
      set_account_user_list_message(getForbiddenResponseMessage(error) || 'Something went wrong');
    } finally {
      __remove('COMMON_API_CALL');
    }
  }

  const gridUpdateCallback = (event) => {
    setAgGridFiltered(event.api.getDisplayedRowCount());
  }
  const onColumnResided = (event) => {
    event.columnApi.getColumn('0').setActualWidth(50);
  }

  const onGridReady = (params) => {
    setAgGridFiltered(params.api.getDisplayedRowCount());
    params.api.addEventListener('filterChanged', gridUpdateCallback)
    params.api.addEventListener('filterModified', gridUpdateCallback)
    params.api.addEventListener('columnResized', onColumnResided);
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
  };

  useEffect(() => {
    if (selectedIndex < 0) {
      return;
    }
    const params = {
      accountNumber: accountDetail?.account_number,
      speedboat: accountDetail?.speedboat,
      salesOrg: accountDetail?.sales_org,
      userId: accountUserList[selectedIndex]?.user_id,
      roles: selectedRoles.map(v => v.roleName),
    }

    async function fetchHere() {
      const res = await update_user_roles(params);
      if (res.isSuccessFull) {
        System.clearAllAlert();
        System.alert(res.data, 'success', 'userAcct')
        setRefreshGrid(true);
      } else {
        System.clearAllAlert();
        System.alert(res.message || res.errorMessage || "Error updating user roles", 'danger', 'userAcct')
      }
    }

    fetchHere();
    setIndex(-1)
  }, [selectedRoles]);

  return (
    <>
      {__check(['ACCOUNT_DETAIL_API_CALL', 'ACCOUNT_USER_API_CALL']).render}
      {!__check(['ACCOUNT_DETAIL_API_CALL', 'ACCOUNT_USER_API_CALL']).status &&
        <>
          {rowData?.length > 0 && accountUserListMessage &&
            <div className='container mt-5'>
              <NoResultContent message={accountUserListMessage} type='danger' isDisplay={false} />
            </div>
          }
          {rowData?.length > 0 &&
            <>
              <div className='w-100 d-flex align-items-center justify-content-between status-bar p-2'>
                <div className="d-flex justify-content-start">
                  Filtered Line Count: <b>{agGridFiltered}</b>
                </div>
                <div className="d-flex justify-content-end">
                  Total Records: <b>{totalAccountUser}</b>
                </div>
              </div>
              <div className='bg-black p-2 px-3'>
                <div className='d-flex align-items-center justify-content-between'>
                  <div className='d-flex align-items-center'>
                    <button disabled={isEdit} className={`bs5 btn btn-secondary ${selectionCount > 0 ? '' : ' disabled'}`} onClick={() => onUnsponsorAcct()}><i className="fas5 fa-user-minus text-darkgreen me-2" aria-hidden="true"></i>UNSPONSOR FROM AN ACCOUNT</button>
                  </div>
                  <div className='d-flex align-items-center'>
                    <span id="emailFilter" className="dropdown">
                      <a href={void (0)} data-toggle="dropdown" aria-expanded="false" className='text-white'>
                        <i className="fa fa-download me-1" aria-hidden="true"></i> Export List
                      </a>
                      <ul className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton1">
                        <li><a href={void (0)} onClick={onExportAll}>Export All</a></li>
                        {rowData?.length > 0 && <li><a href={void (0)} onClick={exportGrid}>Export Filtered</a></li>}
                      </ul>
                    </span>
                  </div>
                </div>
              </div>
            </>}
          {rowData?.length > 0 ?
            <div className="ag-theme-alpine ag-grd-hg mb-5">
              <AgGridReact
                ref={gridRef}
                rowData={rowData}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                rowSelection={'multiple'}
                suppressRowClickSelection={true}
                onSelectionChanged={onSelectionChanged}
                isRowSelectable={isRowSelectable}
                onGridReady={onGridReady}
                excelStyles={excelStyles}
                popupParent={popupParent}
                autoGroupColumnDef={{
                  headerName: 'Group',
                  minWidth: 220,
                }}
              >
              </AgGridReact>
            </div> :
            <div>
              <NoResultContent message={accountUserListMessage || 'No User is associated to this account'} type={accountUserListMessage ? 'danger' : 'info'} isDisplay={false} />
            </div>
          }
        </>
      }
      <RoleSelection />
    </>
  );
}
